module.exports = __webpack_public_path__ + "img/calendar.5dfaa729.svg";